import { createDuration } from './create';

export function clone() {
    return createDuration(this);
}



//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/moment/src/lib/duration/clone.js
// module id = 351
// module chunks = 0